// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { nextMonday as fn } from "../nextMonday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const nextMondayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default nextMondayWithOptions;
